import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const INIT = { username:'', password:'', full_name:'', email:'', role:'viewer', is_active:true };

export default function Users() {
  const [users, setUsers] = useState([]);
  const [audit, setAudit] = useState([]);
  const [tab, setTab] = useState('users');
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(INIT);
  const [editId, setEditId] = useState(null);

  const fetch = async () => {
    const [u, a] = await Promise.all([
      axios.get('/api/users').then(r=>r.data).catch(()=>[]),
      axios.get('/api/users/audit').then(r=>r.data).catch(()=>[]),
    ]);
    setUsers(u); setAudit(a);
  };
  useEffect(() => { fetch(); }, []);

  const openAdd = () => { setForm(INIT); setEditId(null); setModal('form'); };
  const openEdit = u => { setForm({...u, password:''}); setEditId(u.id); setModal('form'); };

  const handleSave = async () => {
    try {
      if (editId) await axios.put(`/api/users/${editId}`, form);
      else await axios.post('/api/users', form);
      toast.success('Αποθηκεύτηκε'); setModal(null); fetch();
    } catch (err) { toast.error(err.response?.data?.error||'Σφάλμα'); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Διαγραφή χρήστη;')) return;
    try { await axios.delete(`/api/users/${id}`); toast.success('Διαγράφηκε'); fetch(); }
    catch (err) { toast.error(err.response?.data?.error||'Σφάλμα'); }
  };

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const roleBadge = r => ({admin:'badge-blue',editor:'badge-green',viewer:'badge-gray'})[r]||'badge-gray';

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
        <div>
          <h1 style={{ fontSize:'22px', fontWeight:700, letterSpacing:'-0.03em' }}>Χρήστες & Audit</h1>
          <p style={{ color:'var(--slate)', fontSize:'12px', marginTop:'3px' }}>{users.length} χρήστες</p>
        </div>
        <button className="btn btn-primary btn-sm" onClick={openAdd}>+ Νέος Χρήστης</button>
      </div>

      <div style={{ display:'flex', gap:'8px', marginBottom:'16px' }}>
        {[['users','Χρήστες'],['audit','Audit Log']].map(([v,l]) => (
          <button key={v} className={`btn btn-sm ${tab===v?'btn-primary':'btn-ghost'}`} onClick={()=>setTab(v)}>{l}</button>
        ))}
      </div>

      {tab==='users' && (
        <div className="tbl-wrap">
          <table>
            <thead><tr><th>Χρήστης</th><th>Email</th><th>Ρόλος</th><th>Τελ. Σύνδεση</th><th>Κατάσταση</th><th style={{width:'72px'}}></th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                      <div style={{ width:'30px', height:'30px', borderRadius:'50%', background:'linear-gradient(135deg,#0A0F1E,#1B4FD8)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', fontWeight:700, color:'#fff', flexShrink:0, fontFamily:'Inter,sans-serif' }}>
                        {(u.full_name||u.username||'U')[0].toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontWeight:500, fontSize:'13px' }}>{u.full_name||u.username}</div>
                        <div style={{ fontSize:'11px', color:'var(--mist)' }}>@{u.username}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ color:'var(--slate)', fontSize:'12px' }}>{u.email||'—'}</td>
                  <td><span className={`badge ${roleBadge(u.role)}`}>{u.role}</span></td>
                  <td style={{ fontSize:'12px', color:'var(--slate)' }}>{u.last_login ? new Date(u.last_login).toLocaleString('el-GR',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : 'Ποτέ'}</td>
                  <td><span className={`badge ${u.is_active?'badge-green':'badge-red'}`}>{u.is_active?'Ενεργός':'Ανενεργός'}</span></td>
                  <td><div style={{ display:'flex', gap:'4px' }}>
                    <button className="btn btn-ghost btn-icon-sm" onClick={()=>openEdit(u)}>✏️</button>
                    <button className="btn btn-ghost btn-icon-sm" style={{ color:'var(--red)' }} onClick={()=>handleDelete(u.id)}>🗑</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab==='audit' && (
        <div className="tbl-wrap">
          <table>
            <thead><tr><th>Χρήστης</th><th>Ενέργεια</th><th>Οντότητα</th><th>Λεπτομέρειες</th><th>IP</th><th>Ημερομηνία</th></tr></thead>
            <tbody>
              {audit.map(l => (
                <tr key={l.id}>
                  <td style={{ fontSize:'12px', fontWeight:500 }}>{l.username||'—'}</td>
                  <td><span className="badge badge-blue" style={{ fontSize:'10px' }}>{l.action}</span></td>
                  <td style={{ fontSize:'12px', color:'var(--slate)' }}>{l.entity}</td>
                  <td style={{ fontSize:'11px', color:'var(--slate)', maxWidth:'180px' }} className="truncate">{l.details||'—'}</td>
                  <td style={{ fontSize:'11px', color:'var(--mist)' }}>{l.ip_address||'—'}</td>
                  <td style={{ fontSize:'11px', color:'var(--slate)', whiteSpace:'nowrap' }}>{new Date(l.created_at).toLocaleString('el-GR',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</td>
                </tr>
              ))}
              {audit.length===0 && <tr><td colSpan={6} style={{ textAlign:'center', padding:'40px', color:'var(--mist)' }}>Κανένα log ακόμα</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal==='form' && (
        <div className="modal-backdrop" onClick={e=>e.target===e.currentTarget&&setModal(null)}>
          <div className="modal-box">
            <h3 className="modal-title">{editId?'Επεξεργασία Χρήστη':'Νέος Χρήστης'}</h3>
            <div className="form-row">
              <div className="form-group"><label className="form-label">Username *</label><input className="input" value={form.username} onChange={e=>set('username',e.target.value)} disabled={!!editId} /></div>
              <div className="form-group"><label className="form-label">Password {editId?'(αφήστε κενό για χωρίς αλλαγή)':' *'}</label><input className="input" type="password" value={form.password} onChange={e=>set('password',e.target.value)} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label className="form-label">Ονοματεπώνυμο</label><input className="input" value={form.full_name} onChange={e=>set('full_name',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Email</label><input className="input" type="email" value={form.email} onChange={e=>set('email',e.target.value)} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label className="form-label">Ρόλος</label>
                <select className="input" value={form.role} onChange={e=>set('role',e.target.value)}>
                  <option value="viewer">Viewer — μόνο ανάγνωση</option>
                  <option value="editor">Editor — επεξεργασία + email</option>
                  <option value="admin">Admin — πλήρης πρόσβαση</option>
                </select></div>
              <div className="form-group"><label className="form-label">Κατάσταση</label>
                <select className="input" value={form.is_active?'1':'0'} onChange={e=>set('is_active',e.target.value==='1')}>
                  <option value="1">Ενεργός</option><option value="0">Ανενεργός</option>
                </select></div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setModal(null)}>Ακύρωση</button>
              <button className="btn btn-primary" onClick={handleSave}>Αποθήκευση</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
